import type { InputHTMLAttributes } from 'react';

interface NeutralSearchControlProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    | 'onChange'
    | 'value'
    | 'type'
    | 'inputMode'
    | 'enterKeyHint'
    | 'autoCapitalize'
    | 'autoCorrect'
    | 'spellCheck'
    | 'autoComplete'
  > {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  clearLabel?: string;
  ariaLabel?: string;
  wrapperClassName?: string;
}

export function NeutralSearchControl({
  value,
  onChange,
  onClear,
  clearLabel = 'Сбросить',
  ariaLabel,
  className = '',
  wrapperClassName = '',
  id,
  name,
  placeholder,
  ...props
}: NeutralSearchControlProps) {
  const resolvedAriaLabel = ariaLabel ?? placeholder ?? 'Поиск';

  return (
    <div className={['relative', wrapperClassName].join(' ')}>
      <input
        id={id}
        name={name}
        {...props}
        type="text"
        inputMode="search"
        enterKeyHint="search"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        aria-label={resolvedAriaLabel}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className={[
          'h-11 w-full rounded-[12px] border border-[rgba(26,26,26,0.08)] bg-[rgba(255,255,255,0.76)] px-4 pr-16 text-[15px] text-[var(--foreground)] outline-none transition-colors placeholder:text-[rgba(26,26,26,0.38)] focus:border-[rgba(26,26,26,0.18)]',
          className,
        ].join(' ')}
      />
      {value && onClear ? (
        <button
          type="button"
          onClick={onClear}
          className="absolute right-2 top-1/2 inline-flex h-7 -translate-y-1/2 items-center rounded-[8px] px-2 text-[12px] font-medium text-[rgba(26,26,26,0.58)] transition-colors hover:bg-[rgba(26,26,26,0.04)] hover:text-[rgba(26,26,26,0.82)]"
        >
          {clearLabel}
        </button>
      ) : null}
    </div>
  );
}
